import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
	faHome, 
	faUser, 
	faBriefcase, 
	faGraduationCap, 
	faHeart 
} from "@fortawesome/free-solid-svg-icons";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;

	return (
		<React.Fragment>
			<div className="nav-container">
				<nav className="navbar">
					<div className="nav-background">
						<ul className="nav-list">
							<li
								className={
									active === "home"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/home" title="Home">
									<FontAwesomeIcon icon={faHome} />
								</Link>
							</li>
							<li
								className={
									active === "about"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/about" title="About">
									<FontAwesomeIcon icon={faUser} />
								</Link>
							</li>
							<li
								className={
									active === "work"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/work" title="Work">
									<FontAwesomeIcon icon={faBriefcase} />
								</Link>
							</li>
							<li
								className={
									active === "education"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/education" title="Education">
									<FontAwesomeIcon icon={faGraduationCap} />
								</Link>
							</li>
							<li
								className={
									active === "life"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/life" title="Life">
									<FontAwesomeIcon icon={faHeart} />
								</Link>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</React.Fragment>
	);
};

export default NavBar;
